<template>
    <div class="joinus">
            <JoinUsStep1 @finish="finish(1)" v-if="step == 0"></JoinUsStep1>
            <JoinUsStep2 @finish="finish(2)" v-else-if="step == 1"></JoinUsStep2>
            <JoinUsStep3 @finish="finish(3)" v-else></JoinUsStep3>
    </div>
</template>
<script>
import JoinUsStep1 from "./JoinUsStep1"
import JoinUsStep2 from "./JoinUsStep2"
import JoinUsStep3 from "./JoinUsStep3"
export default {
    name : "JoinUs",
    components : {
        JoinUsStep1,
        JoinUsStep2,
        JoinUsStep3
    },
    data(){
        return {
            step: 0
        }
    },
    methods: {
        finish(idx){
            console.log('idx', idx)
            this.step = idx
            
        }
    }
}
</script>
<style lang="scss" scoped>
.joinus {
    width: 100%;
    padding-top: 80px;
    padding-bottom: 80px;
    box-sizing: border-box;
    position: relative;
    background-color: #d9f0ec;
  

}
</style>